(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link, NavLink } from 'react-router-dom';
import burgermobile from '../assets/static/icon/burger.svg';
import mosaic from '../assets/static/mosaic.svg';
import ImageWebp from '../components/custom/ImageWebp';
import { NEXT_PUBLIC_PHONE_COMPANY } from '../utils/utilities';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolling: false
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    if (window.scrollY === 0 && this.state.scrolling === true) {
      this.setState({
        scrolling: false
      });
    } else if (window.scrollY !== 0 && this.state.scrolling !== true) {
      this.setState({
        scrolling: true
      });
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: "#content",
      className: "visually-hidden visible-when-focused bypass-block-link"
    }, "Skip Navigation"), /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(Container, {
      className: "d-flex justify-content-between"
    }, /*#__PURE__*/React.createElement("p", {
      className: "headerphone"
    }, "CALL US TODAY! ", /*#__PURE__*/React.createElement("a", {
      href: "tel:3237332258"
    }, NEXT_PUBLIC_PHONE_COMPANY)), /*#__PURE__*/React.createElement("p", {
      className: "d-none d-md-block"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://my-schedule.timetrade.com/app/td-2526949/workflows/kq412/schedule/welcome?wfsid=16a5bdb5-baba97f6-16a5be04-baba97f6-00000002-3lugmnd3ng5b0uvv3s838foon6csf6gn&view=full&fs=1",
      className: "btn btn-secondary",
      target: "_blank",
      rel: "noopener"
    }, "Book a Tour", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, " (opens in new window)")), /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans",
      className: "btn btn-secondary"
    }, "Apply Now")))), /*#__PURE__*/React.createElement(Navbar, {
      className: this.state.scrolling ? `onfloat ${this.props.mode}` : this.props.mode,
      fixed: "top",
      bg: "light",
      expand: "lg"
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Link, {
      to: "/",
      className: "navbar-brand"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/logo.png",
      alt: "The District",
      width: "208",
      height: "50"
    })), /*#__PURE__*/React.createElement(Navbar.Text, {
      className: "order-4"
    }, /*#__PURE__*/React.createElement(ImageWebp, {
      src: mosaic,
      alt: "Mosaic Student Communities",
      className: "mosaicheader",
      width: "68",
      height: "65"
    })), /*#__PURE__*/React.createElement(Navbar.Toggle, {
      "aria-controls": "navbarmain"
    }, /*#__PURE__*/React.createElement("img", {
      src: burgermobile,
      alt: "Open/Hide Menu",
      width: "32",
      height: "21"
    })), /*#__PURE__*/React.createElement(Navbar.Collapse, {
      id: "navbarmain"
    }, /*#__PURE__*/React.createElement(Nav, {
      className: "ms-auto"
    }, /*#__PURE__*/React.createElement(NavLink, {
      to: "/amenities",
      className: "nav-link",
      activeClassName: "active"
    }, "Amenities"), /*#__PURE__*/React.createElement(NavLink, {
      to: "/floorplans",
      className: "nav-link",
      activeClassName: "active"
    }, "FLOOR PLANS"), /*#__PURE__*/React.createElement(NavLink, {
      to: "/neighborhood",
      className: "nav-link",
      activeClassName: "active"
    }, "Neighborhood"), /*#__PURE__*/React.createElement(NavLink, {
      to: "/gallery",
      className: "nav-link",
      activeClassName: "active"
    }, "Gallery"), /*#__PURE__*/React.createElement(NavLink, {
      to: "/contact",
      className: "nav-link",
      activeClassName: "active"
    }, "Contact Us"))))));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Header;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Header, "Header", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Header.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Header.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();